// Pill showing how many days until a Facebook token expires. Green when far
// out, amber inside two weeks, red on the day of / past. Used in the
// Facebook integration card.

interface Props {
  expiresAt: string | null
}

export function TokenExpiryBadge({ expiresAt }: Props) {
  if (!expiresAt) return null

  const days = Math.round((new Date(expiresAt).getTime() - Date.now()) / 86_400_000)
  const date = new Date(expiresAt).toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })

  let tone: 'green' | 'amber' | 'red'
  let label: string
  if (days <= 0) {
    tone = 'red'
    label = 'Expired'
  } else if (days <= 14) {
    tone = 'amber'
    label = `${days}d left`
  } else {
    tone = 'green'
    label = `Expires ${date}`
  }

  const cls =
    tone === 'green'
      ? 'text-jarvis-green border-jarvis-green/30 bg-jarvis-green/10'
      : tone === 'amber'
        ? 'text-jarvis-amber border-jarvis-amber/30 bg-jarvis-amber/10'
        : 'text-jarvis-red border-jarvis-red/30 bg-jarvis-red/10'

  return (
    <span className={`inline-flex items-center gap-1.5 text-[11px] uppercase tracking-wider px-2 py-0.5 rounded-full border ${cls}`}>
      <span className={`inline-block w-1.5 h-1.5 rounded-full ${tone === 'green' ? 'bg-jarvis-green' : tone === 'amber' ? 'bg-jarvis-amber' : 'bg-jarvis-red'}`} />
      {label}
    </span>
  )
}
